// extracted by mini-css-extract-plugin
export default {"Loader":"VideoSpinner_Loader__0Bzqh","load2":"VideoSpinner_load2__y7SmE"};